export default "__VITE_ASSET__CMYSpL5Q__"